import { Alert } from 'antd';

type InfoBoxProps = {
  message: string;
  description?: string;
};

export const AlertBox = ({ message, description, ...props }: InfoBoxProps) => (
  <Alert
    message={message}
    description={description}
    type="info"
    showIcon
    {...props}
  />
);
